import { render } from "./color-swatches.vue?vue&type=template&id=4f6bea00"
import script from "./color-swatches.vue?vue&type=script&lang=js"
export * from "./color-swatches.vue?vue&type=script&lang=js"

import "./color-swatches.vue?vue&type=style&index=0&id=4f6bea00&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__